import { customAxios } from '../../_utils/axios';

// ----------------------------------------------------------------------

const getPredictions = (
  id: string,
  resolve: ( response: {}[] ) => void,
  reject: () => void
) => {
  customAxios(
    {
      method: 'get',
      url: 'water-quality-predictions/iot-device/' + id
    },
    (response) => {
      const data = response.data.data;
      return resolve(
        data.map((value: object, index: number) => { return { ...value, id: index + 1 }})
      );
    },
    () => {
      return reject();
    }
  );
};

export default getPredictions;